/*
 * @Date: 2023-12-29 15:30:06
 * @Author: jm
 * @LastEditTime: 2024-01-12 16:21:08
 * @LastEditors: jm
 * @FilePath: \gameclub\src\services\api.js
 * @Description:
 */
import axiosInstance from "@/utils/request";

export const getgame = (params) => {
  return axiosInstance.post("game", { ...(params || {}) });
};
export const getId = (params) => {
  return axiosInstance.post("gameid", { ...(params || {}) });
};
